import React from 'react';

export const HouseGray = () => (
  <g
    id="g4547"
    transform="matrix(21.61578,0,0,21.61578,0.686289,-0.85383533)"
    strokeWidth="0.0462625"
  >
    <path
      fill="#ffffff"
      strokeWidth="0.0462625"
      id="path4519"
      d="m 42.4,23.45 1.9,2.95 H 42.4 V 48.5 H 7.6 V 26.95 L 4.9,26.15 7.6,23.45 25,5.4 Z"
    />
    <path
      fill="#182b4a"
      strokeWidth="0.0462625"
      d="m 9.1,47.002 0.05,-20.05 c 0,-0.4 -0.15,-0.75 -0.45,-1.05 -0.25,-0.3 -0.65,-0.45 -1.05,-0.45 H 4.4 L 3.95,25.002 25,3.652 35.45,14.302 c 0.45,0.45 1.1,0.6 1.65,0.35 0.6,-0.25 0.95,-0.8 0.95,-1.4 v -6.35 h 2.8 v 12.25 c 0,0.4 0.15,0.75 0.45,1.05 l 4.75,4.8 -0.45,0.45 h -3.25 c -0.35,0 -0.75,0.15 -1.05,0.45 -0.3,0.25 -0.45,0.65 -0.45,1.05 v 20.05 z m 34.75,1.5 v -20.05 h 2.35 c 0.4,0 0.75,-0.15 1.05,-0.45 l 1.95,-1.95 c 0.6,-0.6 0.6,-1.5 0,-2.1 l -5.35,-5.45 v -13.1 c 0,-0.85 -0.65,-1.5 -1.5,-1.5 h -5.8 c -0.85,0 -1.5,0.65 -1.5,1.5 v 4.2 l -9,-9.15 c -0.6,-0.55 -1.6,-0.55 -2.15,0 L 0.7,23.953 c -0.6,0.6 -0.6,1.5 0,2.1 l 1.95,1.95 c 0.3,0.3 0.7,0.45 1.1,0.45 H 6.1 v 20.05 c 0,0.85 0.65,1.5 1.5,1.5 h 34.8 c 0.8,0 1.5,-0.65 1.45,-1.5 z"
    />
    <path
      fill="#c2ccd8"
      strokeWidth="0.0462625"
      d="m 27.2,28.9 h 9.65 v 9.8 H 27.2 Z m -9.95,-6.795 c 1.55,-8.7 13.9,-8.7 15.45,0 z m -4.1,24.897986 V 28.9 h 8.91295 v 18.102986"
    />
    <path
      fill="#ffffff"
      strokeWidth="0.0462625"
      d="m 17.95,35.75 a 1.95,1.95 0 1 0 0,-3.9 1.95,1.95 0 0 0 0,3.9 z"
    />
  </g>
);
